import PodcastName, { PodcastNameProps } from './PodcastName';

export default PodcastName;
export type { PodcastNameProps };
